import './view.fa';
import './view.scss';

$(() => {
    $(document).on('click', '.toggle-list', function() {
        $(this).parent().prev().find('.d-toggle').toggle(100);
        $(this).toggleClass('collapsed');
    });
});
